import React from 'react'
import AiHero from '../../Components/Automation/AiHero'
import WhyAIAutomation from '../../Components/Automation/WhyAIAutomation'
import IndustriesWeServe from '../../Components/Automation/IndustriesWeServe'
import { ArrowRight, CheckCircle, CheckCircle2, Circle } from 'lucide-react'
import Banner from '../../Components/Banner'
import { Helmet } from 'react-helmet-async';
import ApproachPointsSection from './ai/ApproachPointsSection'
import ContactSection from '../../Components/home/ContactSection'

const featuresData = [
    {
        id: 1,
        title: "Honeywell Automation",
        description:
            "Skilled in industrial automation and control systems like TPS, Experion PKS, SCADA, controllers, safety, and advanced process control solutions.",
        image: "/assets/v/item1.png",
    },
    {
        id: 2,
        title: "Siemens Automation",
        description:
            "Smart SIMATIC S7 PLC and reliable control systems for industry.",
        image: "/assets/v/item3.png",
    },
    {
        id: 3,
        title: "ABB Automation",
        description:
            "Advanced automation systems including System 800xA (AC 800M) and Freelance (AC 900F, AC 800F) for reliable and efficient industrial control.",
        image: "/assets/v/item4.png",
    },
    {
        id: 4,
        title: "Allen-Bradley / Rockwell Automation",
        description:
            "Reliable SLC & PLC systems for smarter industrial automation",
        image: "/assets/v/item5.png",
    },
    // {
    //     id: 5,
    //     title: "GE-Fanuc",
    //     description:
    //         "Reliable GE Series 90-30 PLC control system",
    //     image: "/assets/v/item7.jpg",
    // },
];

// --- DATA ---
const services = [
    {
        id: 1,
        title: "Cloud Services",
        category: "service",
        desc: "Elevate your applications with Mobikode’s cloud services designed for performance optimization, data protection and simplicity in migrations. We also cut costs so you can do more of what really matters!",
        defaultBg: "bg-gradient-to-b from-[#01386A] to-[#1C355E]", // Deep Blue Gradient
    },
    {
        id: 2,
        title: "Cloud Migration",
        category: "service",
        desc: "The future is now. Cloud is essential for organizations today to be more efficient and profitable. Mobikode can help you migrate your data into this new way of thinking by strengthening the core operations strategy and build a future-ready organization.",
        defaultBg: "bg-gradient-to-r from-[#01386A] to-[#4B6CB7]", // Blue to Royal Blue (Replaced Orange)
    },
    {
        id: 3,
        title: "DevOps Services",
        category: "service",
        desc: "We implement a continuous and data-driven approach to help you realize better outcomes with your infrastructure through the latest tech trends, tools, techniques – and even old-fashioned hard work!",
        defaultBg: "bg-gradient-to-br from-[#01386A] to-[#8E9EAB]", // Blue to Grayish Blue
    },
    {
        id: 4,
        title: "Cloud Services",
        category: "service",
        desc: "Elevate your applications with Mobikode’s cloud services designed for performance optimization, data protection and simplicity in migrations. We also cut costs so you can do more of what really matters!",
        defaultBg: "bg-gradient-to-b from-[#01386A] to-[#1C355E]", // Deep Blue Gradient
    },
    {
        id: 5,
        title: "Cloud Migration",
        category: "service",
        desc: "The future is now. Cloud is essential for organizations today to be more efficient and profitable. Mobikode can help you migrate your data into this new way of thinking by strengthening the core operations strategy and build a future-ready organization.",
        defaultBg: "bg-gradient-to-r from-[#01386A] to-[#4B6CB7]", // Blue to Royal Blue (Replaced Orange)
    },
    {
        id: 6,
        title: "DevOps Services",
        category: "service",
        desc: "We implement a continuous and data-driven approach to help you realize better outcomes with your infrastructure through the latest tech trends, tools, techniques – and even old-fashioned hard work!",
        defaultBg: "bg-gradient-to-br from-[#01386A] to-[#8E9EAB]", // Blue to Grayish Blue
    },
];

const toolsData = [
    {
        id: 1,
        title: "Cloud",
        desc: "AWS, Azure, Google Cloud",
    },
    {
        id: 2,
        title: "Data Platforms",
        desc: "Snowflake, BigQuery, Redshift, Synapse",
    },
    {
        id: 3,
        title: "BI & Visualization",
        desc: "Power BI, Tableau, Looker",
    },
    {
        id: 4,
        title: "AI & ML",
        desc: "Python, TensorFlow, PyTorch",
    },
    {
        id: 5,
        title: "Integration",
        desc: "Kafka, Airflow, dbt",
    },
];

const outcomesData = [
    {
        id: 1,
        text: "Faster, data-driven decision-making",
    },
    {
        id: 2,
        text: "Single source of truth across the enterprise",
    },
    {
        id: 3,
        text: "Predictive insights & automation",
    },
    {
        id: 4,
        text: "Improved efficiency, cost control & revenue growth",
    },
];

const whyMobikodePoints = [
    "We understand real industrial challenges, not just technology",
    "We build solutions that improve efficiency and reduce manual effort",
    "Our systems are designed to minimize downtime and errors",
    "We focus on practical results that improve daily operations",
    "Our solutions are scalable as your business grows",
    "We stay with you as a long-term technology partner, not just a service provider",
];

const approachData = [
    {
        id: 1,
        step: "01",
        title: "Control System Hardware Engineering",
        desc: [
            "We design reliable industrial control system hardware architecture tailored to real operational needs.",
            "We prepare detailed hardware engineering manuals to ensure smooth system integration.",
            "We create accurate, OEM-specific Bill of Materials (BOM) for efficient production planning.",
            "We support control panel design and assembly, focusing on quality and practicality.",
            "We perform hardware functional testing and power-on validation to ensure system stability.",
            "We manage FAT (Factory Acceptance Test), commissioning, and SAT (Site Acceptance Test) for smooth deployment and performance assurance.",
        ],
    },
    {
        id: 2,
        step: "02",
        title: "Control System Software Engineering",
        desc: [
            "Functional design specifications and complete application documentation",
            "PLC, DCS, and SCADA application development for industrial automation",
            "HMI design, graphics development, configuration, and testing",
            "Seamless integration with third-party systems in process plants",
            "Control system database migration and reverse engineering support",
            "Migration of HMI and graphics to modern automation platforms",
            "End-to-end software FAT, field commissioning, and SAT support",
        ],
    },
    {
        id: 3,
        step: "03",
        title: "Automation Consulting & Specialized Services",
        desc: [
            "Industrial automation consulting for greenfield, migration, and expansion projects",
            "Control system estimation, costing, and end-to-end proposal support",
            "Performance benchmarking and optimization of automation systems",
            "Detailed control system audits and health assessments for reliability",
            "Designing scalable and efficient control system architectures",
            "Migration readiness evaluation with risk assessment and planning",
        ],
    },
    {
        id: 4,
        step: "04",
        title: "On-Site & Lifecycle Automation Support",
        desc: [
            "Annual Preventive Maintenance (APM) for control systems to avoid unexpected breakdowns",
            "Support during plant shutdown and start-up automation for safe operations",
            "On-site commissioning and system validation to ensure everything works as intended",
            "Control panel power-on testing and quick troubleshooting to reduce downtime",
        ],
    },
];

function IndustrialAutomation() {
    return (
        <div>
            <Helmet>
                <title>
                    Industrial Automation Solutions & Services | PLC, DCS & SCADA | Mobikode
                </title>

                <meta
                    name="description"
                    content="Mobikode provides industrial automation solutions and services covering PLC, DCS, SCADA, control system engineering, automation consulting, commissioning, testing, maintenance, and lifecycle support for modern industrial operations."
                />

                <meta
                    name="keywords"
                    content="Industrial Automation Solutions, Industrial Automation Services, Industrial Automation Company, Industrial Automation Consulting, PLC Automation Services, DCS Automation Services, SCADA Solutions, Industrial Control Systems, Control System Engineering, PLC Programming Services, DCS Engineering Services, SCADA Engineering Services, HMI Development, Control Panel Engineering, Automation System Integration, Industrial Automation Migration, Automation Commissioning Services, Factory Automation Solutions, Industrial Automation Maintenance, Industrial Control System Support"
                />

                <link
                    rel="canonical"
                    href="https://www.mobikode.com/industrial-automation"
                />

                <meta
                    property="og:title"
                    content="Industrial Automation Solutions & Services | PLC, DCS & SCADA | Mobikode"
                />

                <meta
                    property="og:description"
                    content="Improve industrial operations with Mobikode's automation expertise across PLC, DCS, SCADA, control systems, hardware and software engineering, commissioning, modernization, and lifecycle support."
                />

                <meta
                    property="og:url"
                    content="https://www.mobikode.com/industrial-automation"
                />

                <meta
                    property="og:type"
                    content="website"
                />

                <meta
                    property="og:image"
                    content="https://www.mobikode.com/assets/service-detail/img19.png"
                />

                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content="Industrial Automation Solutions & Services | PLC, DCS & SCADA | Mobikode"
                />

                <meta
                    name="twitter:description"
                    content="Explore Mobikode's industrial automation services for PLC, DCS, SCADA, HMI, control system engineering, automation consulting, commissioning, testing, migration, and long-term support."
                />

                <meta
                    name="twitter:image"
                    content="https://www.mobikode.com/assets/service-detail/img19.png"
                />
            </Helmet>
            <AiHero title="Industrial Automation Solutions & Services" imgData="/assets/service-detail/img19.png" />
            <section className="w-full py-[60px] lg:py-[100px] bg-white overflow-hidden font-sans">
                <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px]">
                    <div className="w-full bg-white border border-[#D5DDE8] flex flex-col lg:flex-row items-stretch">

                        <div className="w-full lg:w-full max-w-[498px] min-h-[260px] md:min-h-[350px] lg:min-h-[420px] overflow-hidden bg-gray-50">
                            <img
                                src="/assets/v/item13.jpg"
                                alt="ai automation"
                                className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
                            />
                        </div>

                        <div className="w-full lg:w-1/2 p-6 sm:p-10 lg:p-14 flex flex-col justify-center text-left">
                            <p className="font-graphik text-[14px] sm:text-[16px] font-[500] text-[#ED6800] tracking-wide mb-3">
                                Start with the right foundation
                            </p>
                            <h2 className="font-sora text-[20px] lg:text-[30px] font-[600] text-[#01386A] leading-[1.25] tracking-tight mb-5">
                                Industrial Automation Solutions
                            </h2>
                            <p className="font-graphik text-[14px] lg:text-[16px] text-[#49577A] leading-[1.7] font-[500]">
                                We provide complete industrial automation solutions that connect every layer of your operations from field instruments to PLC, DCS, SCADA, and data systems. At Mobikode, we work closely with industries on new projects, upgrades, and existing systems to make operations smoother and more reliable. Our team also handles control panel building, engineering, on-site setup, testing, and long-term support, ensuring your systems run efficiently and consistently.
                            </p>
                        </div>

                    </div>
                </div>
            </section>
            <WhyAIAutomation heading="Industrial Automation Platforms & OEM Expertise" approachData={featuresData} />
            {/* <TechServicesSection title="Explore Our Services" sData={services} /> */}
            {/* <IndustriesWeServe /> */}
            <ApproachPointsSection approachData={approachData} />
            {/* <section className="w-full bg-[#FDFDFD] pb-16 lg:pb-24 relative overflow-hidden">
                <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px] relative z-10">
                  
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
                        {approachData.map((item) => (
                            <div
                                key={item.id}
                                className="relative bg-[#F0F0F0] p-8 min-h-[180px] flex flex-col justify-start overflow-hidden group transition-all duration-300 hover:shadow-lg hover:-translate-y-1 rounded-sm"
                            >
                                <div className="relative z-10">
                                    <h3 className="text-[#01386A] text-[16px] lg:text-[20px] font-[500] font-graphik font-[500] pb-[10px] mb-2 leading-tight">
                                        {item.title}
                                    </h3>
                                    <div className='grid gap-[8px]'>
                                        {item?.desc.map((e, i) => {
                                            return (
                                                <div className='flex items-center gap-[10px]'>
                                                    <Circle size={6} className="text-[#F06115] fill-[#F06115]/10" />
                                                    <p key={i} className="text-[#49577A] text-[14px] lg:text-[16px] font-graphik font-[500] leading-snug">
                                                        {e}
                                                    </p>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                                <div
                                    className="absolute bottom-0 right-0 w-[180px] h-[140px] pointer-events-none transition-transform duration-500 group-hover:scale-110 opacity-50 lg:opacity-100"
                                >
                                    <img src="/assets/career/wrap1.svg" alt="" className="w-full h-full object-contain object-bottom-right" />
                                </div>
                            </div>
                        ))}
                    </div>

                </div>
            </section> */}

            <section className="w-full bg-white font-sans">
                <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px]">
                    <div className="w-full bg-white border border-[#D5DDE8] flex flex-col lg:flex-row items-stretch">

                        <div className="w-full lg:w-1/2 min-h-[300px] sm:min-h-[380px] lg:min-h-[460px] overflow-hidden bg-gray-50">
                            <img
                                src="/assets/what/img6.png"
                                alt="Industrial Automation Services"
                                className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
                            />
                        </div>

                        <div className="w-full lg:w-1/2 p-6 sm:p-10 lg:p-14 flex flex-col justify-center text-left">
                            <p className="font-graphik text-[14px] sm:text-[16px] font-[500] text-[#ED6800] tracking-wide mb-2.5">
                                Start with the right foundation
                            </p>

                            <h2 className="font-sora text-[20px] lg:text-[30px] font-[600] text-[#01386A] leading-[1.3] tracking-tight mb-5">
                                Why Choose Us for Industrial Automation?
                            </h2>

                            <div className="flex flex-col gap-3.5 mb-6">
                                {whyMobikodePoints.map((point, index) => (
                                    <div key={index} className="flex items-start gap-3 group">
                                        <div className="mt-0.5 shrink-0">
                                            <CheckCircle2 size={18} className="text-[#ED6800]" />
                                        </div>
                                        <p className="text-[#01386A] font-graphik text-[14px] lg:text-[16px] font-[500] leading-relaxed transition-colors duration-200 group-hover:text-[#ED6800]">
                                            {point}
                                        </p>
                                    </div>
                                ))}
                            </div>

                            <p className="font-graphik text-[14px] lg:text-[16px] text-[#49577A] leading-[1.6] font-[500] border-t border-[#E6EBEF] pt-4">
                                Partner with us for reliable, scalable, and future-ready industrial automation solutions that drive productivity and operational excellence.
                            </p>
                        </div>

                    </div>
                </div>
            </section>
            {/* <section className="relative w-full h-[400px] lg:h-[507px] flex items-center justify-center overflow-hidden">
                <div className="absolute inset-0 z-0">
                    <img
                        src="/assets/career/img12.png"
                        alt="Industrial Automation Background"
                        className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-black/10"></div>
                </div>
                <div className="relative z-10 w-full max-w-[1440px] mx-auto px-[20px] lg:px-[80px] h-full flex items-center lg:items-center ">
                    <div className="bg-white p-8 lg:p-12 max-w-[600px] shadow-2xl rounded-sm">

                        <h2 className="text-[#01386A] text-[30px] lg:text-[40px] font-[600] font-sora leading-tight mb-6">
                            Industrial Automation Solutions & Services
                        </h2>
                        <p className="text-[#49577A] text-[16px] leading-[24px] font-graphik font-[500] mb-8">
                            Helping manufacturing businesses work smarter with automation that improves productivity, increases precision, and makes every step of operations smoother and more efficient.
                        </p>
                        <a href="/contact" className="inline-flex items-center gap-2 text-[#01386A] underline font-graphik font-[500] font-semibold text-lg hover:gap-3 transition-all duration-300 group">
                            Contact Now
                            <ArrowRight size={20} className="transition-transform group-hover:translate-x-1" />
                        </a>

                    </div>
                </div>
            </section> */}
            <br/>
            <br/>
            <br/>
            <Banner title="Industrial Automation Solutions & Services" text=" Empowering businesses with intelligent, autonomous AI solutions that drive efficiency and innovation." />
       <ContactSection/>
        </div>
    )
}

export default IndustrialAutomation
